import type { DeckStatus } from '../api'

const LABELS: Record<DeckStatus, string> = {
  ACTIVE: 'Active',
  FLAGGED: 'Going quiet',
  LOCKED: 'Locked',
  ARCHIVED: 'Archived',
}

export function StatusBadge({ status }: { status: DeckStatus }) {
  if (status === 'ACTIVE') return null
  return <span className={`badge ${status.toLowerCase()}`}>{LABELS[status]}</span>
}
